import { Action } from '@ngrx/store';

export enum UserActionTypes {
  GET_CURRENT_USER = '[USER] Get User',
  GET_CURRENT_USER_SUCCESS = '[USER] Get User Success',
  GET_CURRENT_USER_ERROR = '[USER] Get User Error',

  UPDATE = '[USER] Update',
  UPDATE_SUCCESS = '[USER] Update Success',
  UPDATE_ERROR = '[USER] Update Error',

  UPDATE_PERSONAL_SUCCESS = '[USER] Update personal data Success',
  UPDATE_PERSONAL_ERROR = '[USER] Update personal data Error',

  UPDATE_CREDENTIALS = '[USER] Update Credentials',
  UPDATE_CREDENTIALS_SUCCESS = '[USER] Update Credentials Success',
  UPDATE_CREDENTIALS_ERROR = '[USER] Update Credentials Error',
}

export class GetCurrentUser implements Action {
  readonly type = UserActionTypes.GET_CURRENT_USER;
}
export class GetCurrentUserSuccess implements Action {
  readonly type = UserActionTypes.GET_CURRENT_USER_SUCCESS;
  constructor(public payload: any) {}
}
export class GetCurrentUserError implements Action {
  readonly type = UserActionTypes.GET_CURRENT_USER_ERROR;
  constructor(public payload: any) {}
}

export class UpdateUser implements Action {
  readonly type = UserActionTypes.UPDATE;
  constructor(public data: any, public isPersonal: boolean = false) {}
}
export class UpdateUserSuccess implements Action {
  readonly type = UserActionTypes.UPDATE_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateUserError implements Action {
  readonly type = UserActionTypes.UPDATE_ERROR;
  constructor(public payload: any) {}
}

export class UpdatePersonalDataSuccess implements Action {
  readonly type = UserActionTypes.UPDATE_PERSONAL_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdatePersonalDataError implements Action {
  readonly type = UserActionTypes.UPDATE_PERSONAL_ERROR;
  constructor(public payload: any) {}
}

export class UpdateUserCredentials implements Action {
  readonly type = UserActionTypes.UPDATE_CREDENTIALS;
  constructor(public payload: any) {}
}
export class UpdateUserCredentialsSuccess implements Action {
  readonly type = UserActionTypes.UPDATE_CREDENTIALS_SUCCESS;
  constructor(public payload: any) {}
}
export class UpdateUserCredentialsError implements Action {
  readonly type = UserActionTypes.UPDATE_CREDENTIALS_ERROR;
  constructor(public payload: any) {}
}

export type UserActions =
  | GetCurrentUser
  | GetCurrentUserSuccess
  | GetCurrentUserError
  | UpdateUser
  | UpdateUserSuccess
  | UpdateUserError
  | UpdateUserCredentials
  | UpdateUserCredentialsSuccess
  | UpdateUserCredentialsError
  | UpdatePersonalDataSuccess
  | UpdatePersonalDataError;
